//Node Modules
import axios from 'axios'

//Types
import { TOC, Node } from 'types/toc'
import { Default } from 'types/context'
import { DocsetInfo, DocsetVersion, Content } from 'types/docset'
import { Format} from 'types/format';
import { SearchResults } from 'types/search'
import { DefaultContext } from 'types/cdc'
import { Navigation } from 'types/navigation'

const BASE_URL = '/docsets'

export function info(alias: string, cfr: string): Promise<DocsetInfo> {
  return axios.get<DocsetInfo>(`${BASE_URL}/${alias}/${cfr}`)
    .then(result => result.data)
}

export function formatAvailable(source: any, alias: string, cfr: string, format: Format, lang: string,  casExt?: string): Promise<string> {
  let url = `${BASE_URL}/${alias}/${cfr}/content/${alias}${casExt ? '-'+casExt : ''}.${format}`
  return axios.head(url, { cancelToken: source.token }).then(() => {
    return `/api${url}?locale=${lang}`
  })
}

export function casFormatAvailable(alias: string, cfr: string, fileName: string, format: Format, lang: string,  casExt?: string): Promise<string> {
  let url = `${BASE_URL}/${alias}/${cfr}/content/${fileName}${casExt ? '-'+casExt : ''}.${format}`
  return axios.head(url).then(() => `/api${url}?locale=${lang}`)
}

export function toc(alias: string, cfr: string, requestor: string | null): Promise<Node[]> {
  return axios.get<TOC>(`${BASE_URL}/${alias}/${cfr}/toc${requestor ? '?requestorId='+requestor : ''}`)
    .then(result => result.data.toc)
}

export function languages(alias: string, cfr: string): Promise<string[]>{
  return axios.get(
    `${BASE_URL}/${alias}/${cfr}/info`
  ).then(result => result.data.locales)
}

export function versions(alias: string, cfr: string): Promise<DocsetVersion[]> {
  return axios.get<DocsetVersion[]>(
    `${BASE_URL}/${alias}/${cfr}/lookup`
  ).then(result => result.data)
}

export function home(alias: string, cfr: string): Promise<Default> {
  return axios.get<Default>(
    `${BASE_URL}/${alias}/${cfr}/contexts?default`
  ).then(result => result.data)
}

export function content(alias: string, cfr: string, page: string): Promise<Content> {
  return axios.get<string>(
    `${BASE_URL}/${alias}/${cfr}/content/${page}`,
    {
      headers: {
        'Content-Type': 'application/html'
      }
    }
  ).then(result => {
    return {alias:alias,cfr:cfr, page: page, content:result.data}
  })
}

export function search(alias: string, cfr: string, query: Object): Promise<SearchResults> {
  return axios.get<SearchResults>(
    `${BASE_URL}/${alias}/${cfr}/search`,
    {
      params: query
    }
  ).then((result:any) => result.data.response as SearchResults)
}

export function defaultContext(alias: string, cfr: string): Promise<DefaultContext> {
  return axios.get<DefaultContext>(`${BASE_URL}/${alias}/${cfr}/contexts?default=true`)
    .then(result => result.data)
}

export function navigation(alias: string, cfr: string, navigation: string): Promise<Navigation> {
  return axios.get<Navigation>(`${BASE_URL}/${alias}/${cfr}/navigation/${navigation}`)
    .then(result => result.data)
}

export function access(alias: string, cfr: string):Promise<void> {
  return axios.get(`${BASE_URL}/${alias}/${cfr}/access`)
}

export function getLatestCFR(alias: string, locale: String):Promise<string> {
  return axios.get(`${BASE_URL}/${locale}/${alias}/getLatestCFR`).then(result => result.request.response).catch(err => undefined)
}
